import type { Status } from './status'
import { curry } from 'ramda'

export interface PermissionBasic {
  id: number
  key: string // 唯一标识，格式: 模块:功能。例如 film:list, staff:ban
  name: string // 名称
  status: Status // 状态, 1:启用，2：禁用
  sort: number // 排序
  scope: PermissionScope // 权限范围
}

export interface Permission extends PermissionBasic {
  implicitIds: number[] // 隐式权限，仅用于API权限检查。例如权限A隐含权限B，则有权限A的用户允许调用权限B的API
  excludeCinemaIds: number[] // 排除的影院，更好的方式可以为影院配置可用的权限集，先用简单方式实现
}

export enum PermissionScope {
  cinema = 'cinema', // 影院
  system = 'sys', // 系统
}

function decodePermission(permission: string) {
  const [mod, act = ''] = permission.split(':', 2)
  const fn = (x: string) => x === '' ? '*' : x
  return [fn(mod), fn(act)] as const
}

// foo:bar, foo:bar √
// foo:*, foo:bar √
// foo, foo:bar √
// bar, foo:bar ×
function matchPermission(a: string, b: string) {
  const [mod1, act1] = decodePermission(a)
  const [mod2, act2] = decodePermission(b)
  const eqFn = (a: string, b: string) => a === b || [a, b].includes('*')
  return eqFn(mod1, mod2) && eqFn(act1, act2)
}

export const permissionMatcher = curry(matchPermission)
